// import React, { useEffect } from "react";
// import { FiSearch, FiLogOut, FiMenu } from "react-icons/fi";
// import Swal from "sweetalert2";
// import "./Navbar.css";

// const Navbar = ({ user, toggleSidebar, onLogout }) => {
//   const apiFetch = async (url, options = {}) => {
//     const token = localStorage.getItem("access");

//     const defaultHeaders = {
//       Authorization: `Bearer ${token}`,
//       "Content-Type": "application/json",
//     };

//     try {
//       const response = await fetch(url, {
//         ...options,
//         headers: {
//           ...defaultHeaders,
//           ...options.headers,
//         },
//       });

//       if (response.status === 401) {
//         // Token expired → Auto logout
//         localStorage.clear();
//         if (onLogout) onLogout();

//         Swal.fire({
//           title: "Session Expired",
//           text: "Your login session has expired. Please log in again.",
//           icon: "warning",
//           timer: 2000,
//           showConfirmButton: false,
//         });

//         return null;
//       }

//       return response;
//     } catch (error) {
//       console.error("API error:", error);
//       throw error;
//     }
//   };

//   // ✅ Manual logout
//   const handleLogout = async () => {
//     const result = await Swal.fire({
//       title: "Are you sure?",
//       text: "You will be logged out from the system.",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Yes, logout!",
//       cancelButtonText: "Cancel",
//       reverseButtons: true,
//       customClass: {
//         popup: "custom-swal-popup",
//       },
//     });

//     if (result.isConfirmed) {
//       try {
//         const refreshToken = localStorage.getItem("refresh");

//         await apiFetch(
//           "https://ambatturindustrialestate.com/api/accounts/logout/",
//           {
//             method: "POST",
//             headers: {
//               "Refresh-Token": refreshToken,
//             },
//           }
//         );

//         Swal.fire({
//           title: "Logged out!",
//           text: "You have been successfully logged out.",
//           icon: "success",
//           timer: 1500,
//           showConfirmButton: false,
//         }).then(() => {
//           localStorage.clear();
//           onLogout();
//         });
//       } catch (error) {
//         console.error("Logout error:", error);
//         localStorage.clear();
//         onLogout();
//       }
//     }
//   };

//   // ✅ Auto logout if token already expired (using JWT exp)
//   useEffect(() => {
//     const token = localStorage.getItem("access");
//     if (!token) return;

//     try {
//       const payload = JSON.parse(atob(token.split(".")[1])); // decode JWT
//       const expiry = payload.exp * 1000; // convert to ms
//       const now = Date.now();

//       if (expiry <= now) {
//         // already expired → logout
//         localStorage.clear();
//         onLogout();
//         Swal.fire({
//           title: "Session Expired",
//           text: "Please log in again.",
//           icon: "warning",
//           timer: 2000,
//           showConfirmButton: false,
//         });
//       } else {
//         // set timeout for auto logout
//         const timeout = expiry - now;
//         const timer = setTimeout(() => {
//           localStorage.clear();
//           onLogout();
//           Swal.fire({
//             title: "Session Expired",
//             text: "Please log in again.",
//             icon: "warning",
//             timer: 2000,
//             showConfirmButton: false,
//           });
//         }, timeout);

//         return () => clearTimeout(timer);
//       }
//     } catch (e) {
//       console.error("Token decode error:", e);
//     }
//   }, [onLogout]);

//   return (
//     <nav className="navbar">
//       <div className="navbar-left">
//         <button className="sidebar-toggle" onClick={toggleSidebar}>
//           <FiMenu size={20} />
//         </button>
//         <img src="/assets/logo/amabattur_logo.png" alt="Logo" />
//       </div>

//       <div className="navbar-center">
//         <div className="search-container">
//           <FiSearch className="search-icon" />
//           <input type="text" placeholder="Search..." className="search-input" />
//         </div>
//       </div>

//       <div className="navbar-right">
//         <div className="user-menu">
//           <div className="user-info">
//             <span className="user-name">
//               {user?.company_name || user?.email}
//             </span>
//             <span className="user-role">Administrator</span>
//           </div>
//           <div className="user-avatar">
//             {user?.company_name?.charAt(0) || user?.email?.charAt(0)}
//           </div>
//           <button className="logout-btn" onClick={handleLogout}>
//             <FiLogOut />
//           </button>
//         </div>
//       </div>
//     </nav>
//   );
// };

// export default Navbar;

import React, { useEffect, useState } from "react";
import {
  FiSearch,
  FiLogOut,
  FiMenu,
  FiStar,
  FiAward,
  FiZap,
  FiUser,
} from "react-icons/fi";
import Swal from "sweetalert2";
import "./Navbar.css";

const Navbar = ({ user, toggleSidebar, onLogout }) => {
  const [userProfile, setUserProfile] = useState(user || {});
  const [loading, setLoading] = useState(!user);

  // ✅ Get user type details
  const getUserTypeDetails = (userType) => {
    if (!userType)
      return { name: "Member", icon: <FiUser />, color: "#6b7280" };

    switch (userType.toLowerCase()) {
      case "gold":
        return { name: "Gold Member", icon: <FiStar />, color: "#ffd700" };
      case "silver":
        return { name: "Silver Member", icon: <FiAward />, color: "#c0c0c0" };
      case "bronze":
        return { name: "Bronze Member", icon: <FiZap />, color: "#cd7f32" };
      default:
        return { name: "Member", icon: <FiUser />, color: "#6b7280" };
    }
  };

  const apiFetch = async (url, options = {}) => {
    const token = localStorage.getItem("access");

    const defaultHeaders = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    try {
      const response = await fetch(url, {
        ...options,
        headers: {
          ...defaultHeaders,
          ...options.headers,
        },
      });

      if (response.status === 401) {
        // Token expired → Auto logout
        localStorage.clear();
        if (onLogout) onLogout();

        Swal.fire({
          title: "Session Expired",
          text: "Your login session has expired. Please log in again.",
          icon: "warning",
          timer: 2000,
          showConfirmButton: false,
        });

        return null;
      }

      return response;
    } catch (error) {
      console.error("API error:", error);
      throw error;
    }
  };

  // ✅ Fetch user profile
  const fetchUserProfile = async () => {
    try {
      setLoading(true);
      const response = await apiFetch(
        "https://ambatturindustrialestate.com/api/api/profile/"
      );

      if (response && response.ok) {
        const profileData = await response.json();
        setUserProfile(profileData);
      } else {
        console.error("Failed to fetch user profile");
        setUserProfile(user || {});
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
      setUserProfile(user || {});
    } finally {
      setLoading(false);
    }
  };

  // ✅ Manual logout
  const handleLogout = async () => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You will be logged out from the system.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, logout!",
      cancelButtonText: "Cancel",
      reverseButtons: true,
      customClass: {
        popup: "custom-swal-popup",
      },
    });

    if (result.isConfirmed) {
      try {
        const refreshToken = localStorage.getItem("refresh");

        await apiFetch(
          "https://ambatturindustrialestate.com/api/accounts/logout/",
          {
            method: "POST",
            headers: {
              "Refresh-Token": refreshToken,
            },
          }
        );

        Swal.fire({
          title: "Logged out!",
          text: "You have been successfully logged out.",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        }).then(() => {
          localStorage.clear();
          onLogout();
        });
      } catch (error) {
        console.error("Logout error:", error);
        localStorage.clear();
        onLogout();
      }
    }
  };

  // ✅ Auto logout if token already expired (using JWT exp)
  useEffect(() => {
    const token = localStorage.getItem("access");
    if (!token) return;

    try {
      const payload = JSON.parse(atob(token.split(".")[1])); // decode JWT
      const expiry = payload.exp * 1000; // convert to ms
      const now = Date.now();

      if (expiry <= now) {
        // already expired → logout
        localStorage.clear();
        onLogout();
        Swal.fire({
          title: "Session Expired",
          text: "Please log in again.",
          icon: "warning",
          timer: 2000,
          showConfirmButton: false,
        });
      } else {
        // set timeout for auto logout
        const timeout = expiry - now;
        const timer = setTimeout(() => {
          localStorage.clear();
          onLogout();
          Swal.fire({
            title: "Session Expired",
            text: "Please log in again.",
            icon: "warning",
            timer: 2000,
            showConfirmButton: false,
          });
        }, timeout);

        return () => clearTimeout(timer);
      }
    } catch (e) {
      console.error("Token decode error:", e);
    }
  }, [onLogout]);

  // ✅ Fetch profile on component mount if user prop is not provided
  useEffect(() => {
    if (!user) {
      fetchUserProfile();
    } else {
      setUserProfile(user);
    }
  }, [user]);

  // Get user display name with fallbacks
  const getDisplayName = () => {
    if (loading) return "Loading...";
    return (
      userProfile?.company_name ||
      userProfile?.ceo_name ||
      userProfile?.email ||
      "User"
    );
  };

  // Get user role with styling
  const getUserRole = () => {
    if (loading) return "Loading...";

    const userType = userProfile?.user_type;
    const userTypeDetails = getUserTypeDetails(userType);

    return userTypeDetails.name;
  };

  // Get user role element with icon and color
  const getUserRoleElement = () => {
    if (loading) {
      return <span className="user-role">Loading...</span>;
    }

    const userType = userProfile?.user_type;
    const userTypeDetails = getUserTypeDetails(userType);

    return (
      <span className="user-role" style={{ color: userTypeDetails.color }}>
        {userTypeDetails.icon}
        {userTypeDetails.name}
      </span>
    );
  };

  // Get avatar initial
  const getAvatarInitial = () => {
    if (loading) return "U";
    return (
      userProfile?.company_name?.charAt(0)?.toUpperCase() ||
      userProfile?.ceo_name?.charAt(0)?.toUpperCase() ||
      userProfile?.email?.charAt(0)?.toUpperCase() ||
      "U"
    );
  };

  // Get avatar with user type color
  const getUserAvatar = () => {
    if (loading) {
      return <div className="user-avatar">U</div>;
    }

    const userType = userProfile?.user_type;
    const userTypeDetails = getUserTypeDetails(userType);

    return (
      <div
        className="user-avatar"
        style={{
          borderColor: userTypeDetails.color,
          boxShadow: `0 0 8px ${userTypeDetails.color}40`,
        }}
      >
        {getAvatarInitial()}
      </div>
    );
  };

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <button className="sidebar-toggle" onClick={toggleSidebar}>
          <FiMenu size={20} />
        </button>
        <img src="/assets/logo/amabattur_logo.png" alt="Logo" />
      </div>

      <div className="navbar-center">
        <div className="search-container">
          <FiSearch className="search-icon" />
          <input type="text" placeholder="Search..." className="search-input" />
        </div>
      </div>

      <div className="navbar-right">
        <div className="user-menu">
          <div className="user-info">
            <span className="user-name">{getDisplayName()}</span>
            {getUserRoleElement()}
          </div>
          {getUserAvatar()}
          <button className="logout-btn" onClick={handleLogout}>
            <FiLogOut />
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
